export const dashboardEnglish = {
  overview: "Overview",
  previous_period_delta: "{{delta}} vs previous period",
  delta_previous: "Change",
  delta_previous_help:
    "Change in time vs the previous {{count}} days ({{from}} - {{to}}). A dash means no time was observed then.",
  delta_previous_help_one:
    "Change in time vs the previous day ({{from}}). A dash means no time was observed then.",
  time_change_help: "Change in time spent compared with {{from}} – {{to}}.",
  no_previous_data: "No previous data",
  no_data: "No data",
  view_all_processes: "View all processes",
  ask: "Ask",
  ask_title: "Ask about your team's work",
  next_step: "Next step",
  next_step_description: "Click any process above to see its details and the apps it uses.",
  next_step_hint: "Not sure where to start?",
  next_step_ask: "Ask a question about your team's work.",
  recordings: "Sessions",
  process_overview: "Process overview",
  my_work: "My work",
  my_work_subtitle: "See what Platonic has learned from the work you've shared.",
  my_processes: "Where your time goes",
  my_apps: "Apps you work in",
  people_observed: "People observed",
  sessions_captured: "Sessions captured",
  people_observed_help:
    "People with at least one non-archived session in the selected people and date range, including sessions awaiting analysis.",
  sessions_captured_help:
    "Your non-archived sessions in the selected date range, including sessions awaiting analysis.",
  review_work_title: "Does this look like your work?",
  review_work_description:
    "Help us make this even more accurate by reviewing your processes and sharing feedback.",
  review_my_processes: "Review my processes",
  pending_review_description: "Nothing leaves this computer until you approve it.",
  pending_review_action: "Review sessions",
  empty_review_sessions: "Review your sessions to start seeing your work here.",
  overview_processes: "Where your team's time goes",
  overview_apps: "Apps your team works in",
  overview_apps_hint: "Time spent by application across all processes.",
  total_process_time: "Total process time",
  across_processes: "across {{count}} processes",
  longest_average: "Longest average case",
  key_insight: "Key insight",
  process_insight: "{{process}}: {{finding}}",
  largest_insight: "{{process}} takes the largest share of working time.",
  largest_insight_detail:
    "{{share}}% of observed process time in the selected people and date range.",
  average_run: "Average per case",
  show_all_processes: "Show all {{count}} processes",
  show_all_apps: "Show all {{count}} apps",
  percent_time: "% of time",
  team_overview: "Team overview",
  people: "Team members",
  sessions: "Sessions recorded",
  processes: "Processes observed",
  active_time: "Time spent on processes",
  active_time_help:
    "Active working time attributed to observed processes. Excludes waiting between activities and sessions.",
  slowest: "Slowest process",
  slowest_help: "The process with the highest average active working duration per observed case.",
  average_cycle: "Average cycle time",
  apps: "Apps used",
  largest: "Largest time consumer",
  by_process: "By process",
  by_app: "By app",
  app: "App",
  app_table: "Time by app",
  other_apps: "Other apps",
  no_app: "No app",
  no_app_help:
    "The difference between process time and app-attributed time. This does not mean idle time.",
  observed_app_time: "observed app time",
  empty_apps: "No app time available for this selection.",
  show_more_apps: "Show more",
  show_less_apps: "Show less",
  time_allocation: "Time allocation",
  time_by_process: "Time by process",
  time_by_app: "Time by app",
  select_process_hint: "Select a process to see its details and app usage.",
  clear_selection: "Clear selection",
  selected_process: "Selected process",
  process_graph: "Process graph",
  open_process_graph: "Open the process graph",
  open_process_graph_for: "Open the process graph for {{process}}",
  process_table: "Your team's processes",
  process: "Process",
  observations: "Times observed",
  avg_time: "Avg time",
  total_time: "Total time",
  process_time: "Process time",
  share: "Share of time",
  people_view: "Sessions by person view",
  table_view: "Table",
  timeline_view: "Timeline",
  timeline_label: "Recording time by person",
  recorded_time: "Recorded time",
  timeline_total_help:
    "Recorded time in the displayed days. Overlapping recordings count only once.",
  unnamed_session: "Work session",
  sessions_by_person: "Sessions by person",
  team_member: "Team member",
  people_filter: "People",
  people_selected: "{{count}} people",
  people_selected_one: "{{count}} person",
  date_range: "Date range",
  last_thirty_days: "Last 30 days",
  last_n_days: "Last {{count}} days",
  previous_n_days: "Previous {{count}} days",
  previous_n_days_one: "Previous {{count}} day",
  last_n_days_one: "Last {{count}} day",
  calendar_activity_legend: "Dots mark days when sessions started for the selected people.",
  calendar_activity_loading: "Loading activity dates…",
  calendar_activity_failed: "Activity dates unavailable.",
  calendar_sessions: "{{count}} sessions started this day",
  calendar_sessions_one: "{{count}} session started this day",
  previous_month: "Previous month",
  next_month: "Next month",
  choose_start_date: "Select the first day of your range",
  choose_end_date: "Select the last day of your range",
  select_date_range: "Select a start and end date",
  all_time: "All time",
  custom_range: "Custom dates",
  empty_processes:
    "No processes observed in this period. Choose another date range or view all processes.",
  load_failed: "Couldn't load process metrics. Your sessions are still available below.",
  overview_load_failed: "Couldn't load the process overview.",
  observed_time: "observed process time",
  other_processes: "Other processes",
  invalid_dates: "Choose an end date on or after the start date.",
  team_overview_help_label: "About the team overview",
  team_overview_help:
    "Includes the selected team members, even those with no sessions. Summary totals cover non-archived sessions in the selected date range. Process counts and working time use completed analyses. Search, duration and archive filters apply to the session browser below.",
  empty_team: "No team members available.",
  people_pagination: "Sessions by person pagination",
} as const;
